import { inject, Injectable } from '@angular/core';
import { AppGlobalService } from './app.global.service';

@Injectable({
  providedIn: 'root'
})
export class DataModelService {
  appGlobalService = inject(AppGlobalService);

  private appId: string = '';
  private datamodels: any[] = [];
  private lastUpdatedTime: Date | null = null;

  areDataModelsAvailable(): boolean {
    let isDataModelsAvailable = false;

    // Check if the stored datampdel appId matches the current active appId and if data models were updated within the last 5 minutes
    if (this.appGlobalService.get('appId') == this.appId) {
      if (this.datamodels?.length && this.lastUpdatedTime) {
        const timeDiff = (new Date()).getTime() - this.lastUpdatedTime.getTime();
        if (timeDiff < (1000 * 60 * 5)) { // 5 minutes
          isDataModelsAvailable = true;
        }
      }
    }

    return isDataModelsAvailable;
  }

  getDataModels(): any[] {
    return this.datamodels;
  }

  getLastUpdatedTime(): Date | null {
    return this.lastUpdatedTime;
  }

  storeDataModels(appId: string, datamodels: any[]) {
    this.appId = appId;
    this.datamodels = datamodels;
    this.lastUpdatedTime = new Date();
  }

  clearStoredDataModels() {
    this.appId = '';
    this.datamodels = [];
    this.lastUpdatedTime = null;
  }
}
